import React from "react";

import { FileText, Info } from "lucide-react";

import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { SalesRequest } from "~/types/client";

interface TelechequeIdCardProps {
  selectedOrder: SalesRequest;
  isEditing: boolean;
  setIsEditing: (v: boolean) => void;
  editedValue: string;
  setEditedValue: (v: string) => void;
  isSaving: boolean;
  onSave: () => Promise<void>;
}

export const TelechequeIdCard: React.FC<TelechequeIdCardProps> = ({
  selectedOrder,
  isEditing,
  setIsEditing,
  editedValue,
  setEditedValue,
  isSaving,
  onSave,
}) => {
  return (
    <div className="overflow-hidden rounded-xl border border-gray-300 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-gray-200 bg-gray-100 px-5 py-3">
        <h3 className="flex items-center text-lg font-semibold text-gray-800">
          <FileText className="mr-2 h-5 w-5 text-gray-600" />
          ID de Telecheque
        </h3>
        {!isEditing && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsEditing(true)}
          >
            {selectedOrder.telecheque_id ? "Editar" : "Agregar"}
          </Button>
        )}
      </div>

      <div className="p-5">
        {!isEditing ? (
          <p
            className={`text-sm ${selectedOrder.telecheque_id ? "text-gray-700" : "text-muted-foreground"}`}
          >
            {selectedOrder.telecheque_id ||
              "No se ha asignado un ID de Telecheque."}
          </p>
        ) : (
          <div className="space-y-3">
            <div>
              <label className="mb-1 block text-sm font-medium">
                ID de Telecheque:
              </label>
              <Input
                value={editedValue}
                onChange={(e) => setEditedValue(e.target.value)}
                placeholder="Ingrese el ID de Telecheque"
                disabled={isSaving}
              />
            </div>

            <div className="flex justify-end gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  setIsEditing(false);
                  setEditedValue(selectedOrder.telecheque_id || "");
                }}
                disabled={isSaving}
              >
                Cancelar
              </Button>
              <Button size="sm" onClick={onSave} disabled={isSaving}>
                {isSaving ? "Guardando..." : "Guardar"}
              </Button>
            </div>
          </div>
        )}

        <p className="mt-2 flex items-center text-xs text-muted-foreground">
          <Info className="mr-1 h-4 w-4" />
          Este ID se utilizará en la factura para identificar la garantía
          aprobada de Telecheque
        </p>
      </div>
    </div>
  );
};
